import React from "react";
import { useAppContext } from "../../AppProvider";
import { ButtonUtility } from "../../Components/common/Buttons/ButtonUtility";
import { ButtonConfirm } from "../../Components/common/Buttons/ButtonConfirm";
import { useConfirmOrderContext } from "./providers/Confirm";

const Confirm = () => {
  const { dictionary } = useAppContext();

  const context = useConfirmOrderContext();

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col">
          <label className="label-4 text-center">
            {dictionary.actions.confirm}
          </label>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col">
          <label className="label-5 text-center">
            {context.orders?.length > 1
              ? `${dictionary.messages.ask_confirm_confirmation} ${
                  context.orders?.length
                } ${dictionary.words.items.toLowerCase()}?`
              : `${dictionary.messages.are_you_sure_you_want_to_continue}`}{" "}
            <span className="fw-bold">
              {context.orders[0].cashOnDeliveryValue &&
                `${dictionary.options.cash_on_delivery}: ${context.orders[0].cashOnDeliveryValue} €`}
            </span>
          </label>
        </div>
      </div>
      <div className="d-flex">
        <ButtonUtility
          className="w-50 me-2"
          onClick={() => {
            if (context.callback) {
              context.callback();
            }
          }}
        >
          {dictionary.actions.cancel}
        </ButtonUtility>
        <ButtonConfirm
          className="w-50"
          onClick={() => context.confirmOrders()}
          disabled={context.ordersLoader}
          loading={context.ordersLoader}
        />
      </div>
    </React.Fragment>
  );
};

export default Confirm;
